import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { dict } from "./dict";

const LangCtx = createContext({ lang: "fr", setLang: () => {}, t: dict.fr });

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const stored = typeof window !== "undefined" && localStorage.getItem("tt_lang");
    if (stored && dict[stored]) return stored;
    return "fr";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("tt_lang", lang);
      document.documentElement.setAttribute("lang", lang);
    }
  }, [lang]);

  const value = useMemo(
    () => ({ lang, setLang, t: dict[lang] }),
    [lang]
  );

  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
